<script lang="ts">
  export let embedId: string;
</script>

<div class="youtube-wrapper">
  <iframe
    class="youtube-wrapper__iframe"
    width="560"
    height="315"
    src="https://www.youtube-nocookie.com/embed/{embedId}"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>
</div>

<style lang="scss">
  .youtube-wrapper {
    margin-inline: auto;
    position: relative;
    width: 80%;
    max-width: 1000px;
    border-radius: 14px;
    border: 10px solid $color-white;
    box-shadow: 0px 6px 24px rgba(29, 29, 27, 0.05);
    &__iframe {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      aspect-ratio: 16/9;
    }
  }
</style>
